export default __webpack_public_path__ + "static/media/image_full_75.0da826fc.svg";